<template>
    <v-dialog
            persistent
            max-width="70%"
            v-model="poisk_dialog"
          >
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >Поиск товары

                <v-spacer></v-spacer>
                <v-btn icon @click="close_molho">
                  <v-icon >mdi-close</v-icon>
                </v-btn>

            </v-toolbar>

              <v-card-text>

                    <v-card-title>



                      <v-text-field
                        v-model="search_molho"
                        append-icon="mdi-magnify"
                        label="Поиск по названию"
                        single-line
                        hide-details

                        autofocus
                        clearable
                      ></v-text-field>
                      <v-spacer></v-spacer>

                      <v-text-field
                      v-model="search_barcode"
                      append-icon="mdi-magnify"
                      label="Поиск по  штрихкоду"
                      single-line
                      hide-details
                      @keypress.enter="get_id_mol_enter"
                      autofocus
                      clearable
                    ></v-text-field>



                    </v-card-title>
                    <v-data-table

                      :headers="header_molho"
                      :items="molho"
                      :search="search_molho"
                      :loading="loading"
                      @dblclick:row="get_id_mol_dbl"

                      class="elevation-1"
                      loading-text="Загрузка. Пожалуйста подождите"
                      :footer-props="{
                          'items-per-page-options': [ 7, 20, 50, 100],
                          'items-per-page-text':'Строк на странице',
                      }"
                      no-data-text="Данные отсутствуют в таблице"
                    >
                </v-data-table>

              </v-card-text>


            </v-card>





          </v-dialog>
</template>

<script>
export default {

    data() {
        return {
            search_molho: '',
            poisk_dialog:true,
            loading: false,
            search_barcode:'',

            header_molho: [
          {
            text: 'Код',
            align: 'start',
            value: 'kod',

          },
          { text: 'Наименование', value: 'nom' },
          { text: 'Цена продажа', value: 'narkhi_f' },
          { text: 'Остаток магазин', value: 'OST_M' },
          { text: 'Остаток склад', value: 'OST_S' },
          { text: 'id_mol', value: 'id_mol',  align: ' d-none' },



        ],

        molho:[],

        }
    },

    mounted() {
        this.get_molho_p()
    },

    methods:{
        close_molho(){
            this.$emit('close_molho')
        },

        get_molho_p(){

            this.loading = true;
              axios.get('/api/get_molho_p',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.molho = response.data.molho;
                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения клиентов"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });

        },

        get_id_mol_dbl(event, {item}){
            this.$emit('get_id_mol_dbl', item.id_mol)
        },
        get_id_mol_enter(){
            var kod = +this.search_barcode;
            this.$emit('get_id_mol_enter', kod);
            this.search_barcode = '';
        }
    }

}
</script>

<style>

</style>





